'use strict'

module.exports = {
  properties: {},
  events: {}
}
